const routes = [
  {
    path: 'assembly-planning',
    component: () => import(/* webpackChunkName: "assembly-planning" */ './views/Index.vue'),
    meta: {
      permissionRequired: true,
    },
    children: [
      {
        path: '',
        name: 'assemblyPlanning',
        component: () => import(/* webpackChunkName: "assembly-planning" */ './views/ProductionPlanning.vue'),
      },
      {
        path: 'settings/:id?',
        name: 'assemblyPlanSettings',
        component: () => import(/* webpackChunkName: "assembly-planning" */ './views/ProductionPlanSettings.vue'),
      },
      {
        path: 'plan',
        name: 'addAssemblyPlan',
        component: () => import(/* webpackChunkName: "assembly-planning" */ './views/AddProductionPlan.vue'),
      },
      {
        path: 'reorder',
        name: 'reorderAssemblyPlans',
        component: () => import(/* webpackChunkName: "assembly-planning" */ './views/ReorderProductionPlans.vue'),
      },
      {
        path: 'plan/:id',
        name: 'assemblyPlanDetails',
        component: () => import(/* webpackChunkName: "assembly-planning" */ './views/ProductionPlanDetails.vue'),
        props: true,
      },
      {
        path: 'plan/:id/edit',
        name: 'editAssemblyPlan',
        component: () => import(/* webpackChunkName: "assembly-planning" */ './views/EditProductionPlan.vue'),
        props: true,
      },
      {
        path: 'plan/:id/duplicate',
        name: 'duplicateAssemblyPlan',
        component: () => import(/* webpackChunkName: "assembly-planning" */ './views/DuplicateProductionPlan.vue'),
        props: true,
      },
    ],
  },
];

export default routes;
